export const CSSRS_QUESTIONS = [
  "Have you wished you were dead or wished you could go to sleep and not wake up?",
  "Have you actually had any thoughts of killing yourself?",
  "Have you been thinking about how you might do this?",
  "Have you had these thoughts and had some intention of acting on them?",
  "Have you started to work out or worked out the details of how to kill yourself? Did you intend to carry out this plan?",
  "Have you ever done anything, started to do anything, or prepared to do anything to end your life? (past 3 months)",
];

export function computeCssrsRisk(answers) {
  if ([3, 4, 5].some((i) => answers[i] === "Yes")) return "High risk - intent, plan, or behavior";
  if (answers[2] === "Yes") return "Moderate risk - method";
  if (answers[0] === "Yes" || answers[1] === "Yes") return "Low risk - ideation";
  if (CSSRS_QUESTIONS.every((_, i) => answers[i] === "No")) return "No risk indicated";
  return "Screening incomplete";
}

const RISK_STYLE = {
  "No risk indicated": "border-[#C8E6C9] bg-[#E8F5E9] text-[#2E7D32]",
  "Low risk - ideation": "border-[#FFE082] bg-[#FFF8E1] text-[#876600]",
  "Moderate risk - method": "border-[#FFCC80] bg-[#FFF3E0] text-[#B84A00]",
  "High risk - intent, plan, or behavior": "border-[#FFCDD2] bg-[#FFEBEE] text-[#C62828]",
  "Screening incomplete": "border-[#E5DFD3] bg-[#F5F2EB] text-[#7B6157]",
};

export function CssrsScreener({ value, onChange, testId = "cf-cssrs" }) {
  const answers = (value && value.answers) || [];
  const setAns = (i, v) => {
    const next = [...answers];
    next[i] = v;
    onChange({ answers: next, risk: computeCssrsRisk(next) });
  };
  const risk = computeCssrsRisk(answers);
  return (
    <div data-testid={testId} className="space-y-2 rounded-xl border border-[#EFEBE0] bg-[#FDFCF8] p-4">
      <div className="text-xs text-[#7B6157]">Ask the client: in the past month…</div>
      {CSSRS_QUESTIONS.map((q, i) => (
        <div key={i} className="flex items-center justify-between gap-3 rounded-lg border border-[#F1EEE7] bg-white px-3 py-2">
          <span className="text-sm text-[#3E2723]"><b className="mr-1 text-[#7B6157]">{i + 1}.</b>{q}</span>
          <span className="flex shrink-0 gap-1">
            {["Yes", "No"].map((o) => (
              <button key={o} type="button" data-testid={`${testId}-q${i + 1}-${o.toLowerCase()}`} onClick={() => setAns(i, o)}
                className={`rounded-full px-3 py-1 text-xs font-bold transition-colors ${answers[i] === o ? (o === "Yes" ? "bg-[#C62828] text-white" : "bg-[#2E7D32] text-white") : "bg-[#F5F2EB] text-[#6D4C41] hover:bg-[#EDE7DC]"}`}>
                {o}
              </button>
            ))}
          </span>
        </div>
      ))}
      <div data-testid={`${testId}-risk`} className={`rounded-lg border px-3 py-2 text-sm font-bold ${RISK_STYLE[risk]}`}>
        Risk level: {risk}
        {risk.startsWith("High") && (
          <div className="mt-0.5 text-xs font-medium">Initiate the crisis protocol, ensure client safety, and notify the prescriber or on-call clinician immediately.</div>
        )}
      </div>
    </div>
  );
}
